import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../EffectVisuals.scss';

const EveryVisualizer = ({
    effect,
    sequencerEngine,
    currentStep,
    every,
    offset
}) => { 
    let steps = [];
    for (let i=0 ; i < every; i++) {
        steps.push(i);
    }
    let current = (effect.counter % every) - 1;
    if (effect.counter % every === 0) {
        current = every - 1;
    }
    return (
        <div className="every-visualizer">
          {steps.map(
              x =>
                  <div
                    className={
                        x === current && x === offset  ? "step current offset" :
                        x === current ? "step current" :
                        x === offset ? "step offset" : "step"}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      currentStep: props.sequencerEngine.lastTrackStep,
      every: props.effect.every,
      offset: props.effect.offset
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EveryVisualizer);
